import { render } from "./TheMyCollectionItemListView.vue?vue&type=template&id=4d3bce5b&scoped=true&ts=true"
import script from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"

import "./TheMyCollectionItemListView.vue?vue&type=style&index=0&id=4d3bce5b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3bce5b"]])

export default __exports__